import {createSlice} from '@reduxjs/toolkit';
import {MqttGrab} from '../../data/mqttGrab';
import {getMqttGrabList} from '../../action/efe/mqttGrabAction';

interface MqttGrabState {
    messages: MqttGrab[];
    loading: boolean;
    error: string | null;
    requestId: string | null;
}

const initialState: MqttGrabState = {messages: [], loading: false, error: null, requestId: null};

const mqttGrabSlice = createSlice({
    name: 'mqttGrab',
    initialState,
    reducers: {
        clear: () => initialState
    },
    extraReducers: builder => {
        builder.addCase(getMqttGrabList.pending, (state, action) => {
            state.messages = [];
            state.loading = true;
            state.error = null;
            state.requestId = action.meta.requestId;
        });
        builder.addCase(getMqttGrabList.fulfilled, (state, action) => {
            if (state.requestId !== action.meta.requestId) return;
            state.messages = action.payload;
            state.loading = false;
            state.requestId = null;
        });
        builder.addCase(getMqttGrabList.rejected, (state, action) => {
            if (state.requestId !== action.meta.requestId) return;
            state.loading = false;
            state.requestId = null;
            state.error = action.meta.aborted ? null : action.error.message || 'UNKNOWN';
        });
    }
});

export const mqttGrabActions = mqttGrabSlice.actions;
export default mqttGrabSlice;
